var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "" } },
        [
          _c("BuscadorFacturacion", {
            attrs: {
              listaTipoDocumentos: _vm.lstDocumentos,
              listaEstados: _vm.lstEstados
            },
            on: {
              resultadoBusqueda: _vm.filtroFacturacion,
              clear: _vm.facturaInicial
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _c("VerFacturaModal", {
        attrs: {
          show: _vm.mostrarModalVer,
          facturaSeleccionada: _vm.facturaSeleccionada
        },
        on: { cerrar: _vm.handleCierreModalVer }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }